const getTemplates = ({ workLook }) => ({
  templatesRequestStatus: workLook.templates.requestStatus,
  templatesList: workLook.templates.data,
});

export default getTemplates;
